;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();const processString = (str: string, replacements: [string, string][]) => {
  let result = str.trim().toLowerCase();

  replacements.forEach(([searchValue, replaceValue]) => {
    result = result.split(searchValue).join(replaceValue);
  });

  return encodeURIComponent(result);
};

export const getNameSlug = (name: string) =>
  processString(name, [
    ["'", '_'],
    ['/', '_'],
    [' ', '_'],
    [':', ''],
    ['&', 'and'],
  ]);

export const getStreetSlug = (street: string) =>
  processString(street, [
    [' ', '-'],
    [':', ''],
    ['/', '_'],
    ['&', 'and'],
  ]);

export const getCitySlug = (city: string) =>
  processString(city, [
    [' ', '-'],
    ['&', 'and'],
  ]);

export const getAreaSlug = (area?: string) => (area ? processString(area, [[' ', '-']]) : '');
export const getDistrictSlug = (district?: string) =>
  district ? processString(district, [[' ', '-']]) : '';

const decodeSlug = (slug: string) => {
  try {
    return decodeURIComponent(slug);
  } catch {
    return slug;
  }
};

const mapParams = <T extends Record<string, string>>(params: T, map: (value: string) => string) =>
  Object.fromEntries(Object.entries(params).map(([key, value]) => [key, map(value)])) as T;

// Next 16 passes a page its params percent-encoded but generateMetadata decoded, so
// normalise both or non-ASCII slugs 404 on one side. Location slugs above are stored
// encoded; Prismic UIDs are stored decoded.
export const encodeSlugParams = <T extends Record<string, string>>(params: T): T =>
  mapParams(params, (value) => encodeURIComponent(decodeSlug(value)));

export const decodeSlugParams = <T extends Record<string, string>>(params: T): T =>
  mapParams(params, decodeSlug);
